'use strict';

var ConfigurationParameterModalGridAddRowButtonController = function ConfigurationParameterModalGridAddRowButtonController($scope, systemConfigButtonsUtilsService) {
  var DECORATE_FROM_PARENT_ROW = ['fareBrandNormalizationParams', 'fareBrandDefinitionParams', 'fareBrandAssignmentParams'];
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isAddRowButtonShown = $scope.isGridEditable && !$scope.isDefaultLevel;
  $scope.generateDataForNewRow = function () {
    var data = {};
    data.isNewlyAdded = true;
    if ($scope.parentFieldName && ($scope.parentFieldName === 'businessRulesProperties' || $scope.parentFieldName === 'fareClassMappingProperties')) {
      data.cabin = $scope.parentRow.foCabin;
      data.origin = $scope.parentRow.origin;
      data.destination = $scope.parentRow.destination;
      data.category = $scope.parentRow.category;
      data.benchmarkFareComponent = '1111111';
    }
    if (DECORATE_FROM_PARENT_ROW.indexOf($scope.parentFieldName) > -1) {
      data.carrier = $scope.parentRow.carrier;
    }
    return data;
  };
  $scope.addRow = function () {
    systemConfigButtonsUtilsService.addRowToGrid($scope.generateDataForNewRow(), gridPanel);
    systemConfigButtonsUtilsService.reloadGrid(gridPanel);
  };
};
ConfigurationParameterModalGridAddRowButtonController.$inject = ['$scope', 'SystemConfigButtonsUtilsService'];
module.exports = ConfigurationParameterModalGridAddRowButtonController;